<template>
  <v-form>
    <v-row dense>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" xs="12" md="4">
            <v-text-field
              outlined
              dense
              label="Cargo Name"
              v-model="record.Name"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" md="4">
            <v-autocomplete
              dense
              outlined
              v-model="record.industry_id"
              :items="industries"
              label="Industry"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="4">
            <DatePicker
              @date="setDate"
              :myDate="date"
              :title="`Date Received`"
            ></DatePicker>
          </v-col>

          <v-col cols="12">
            <v-btn
              v-if="docCreate == true"
              color="accent"
              @click="sendData"
              :loading="loader"
            >
              <v-icon left>mdi-content-save</v-icon>Save
            </v-btn>

            <v-btn v-else color="accent" @click="sendData" :loading="loader">
              <v-icon left>mdi-content-save</v-icon>Update
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "StoresIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    record: {},
    loader: false,
    industries: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    sendData() {
      if (
        this.record.Name == undefined ||
        this.record.industry_id == undefined
      ) {
        this.$refs.snackbar.show("Please fill all fields", "red");
      } else {
        this.loader = true;
        this.record.ParentID = this.activeStore;
        this.record.StrType = 2;
        this.$emit("data", this.record);
      }
    },
    getIndustries() {
      const self = this;
      this.$store
        .dispatch("get", `/industries`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.industries = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getIndustries();
  },
};
</script>